<template>
  <Transition name="loader-pop">
    <div v-if="loadingStore.isLoading" class="fixed inset-0 z-[99999] flex items-center justify-center bg-[#111111]/80 backdrop-blur-none p-4 font-sans">
      <div class="loader-card bg-white border-3 border-[#111111] shadow-[10px_10px_0_#111111] p-8 sm:p-10 max-w-sm w-full flex flex-col items-center text-center relative z-10 font-grotesk">
        <!-- Brand Header Badge -->
        <div class="bg-[#064e3b] text-white border-2 border-[#111111] shadow-[3px_3px_0_#111111] px-3 py-1 text-xs font-black uppercase tracking-wider mb-6">
          PORTAL SINAU ACADEMIC
        </div>

        <!-- Square Icon Container with Animated Spinner -->
        <div class="w-16 h-16 bg-[#fbbf24] border-2 border-[#111111] shadow-[4px_4px_0_#111111] flex items-center justify-center mb-6 relative">
          <i class="fas fa-spinner fa-spin text-2xl text-[#111111]"></i>
        </div>

        <!-- Text Content -->
        <h3 class="text-xl font-black text-[#111111] uppercase tracking-tight mb-2">
          MEMUAT DATA...
        </h3>
        <p class="text-xs font-bold text-[#ea580c] uppercase tracking-wide leading-relaxed">
          {{ loadingStore.loadingMessage || 'Mohon tunggu sebentar' }}
        </p>

        <!-- Progress Block Array -->
        <div class="flex gap-1.5 mt-6">
          <div class="w-3 h-3 bg-[#064e3b] border border-[#111111] animate-pulse"></div>
          <div class="w-3 h-3 bg-[#fbbf24] border border-[#111111] animate-pulse [animation-delay:0.2s]"></div>
          <div class="w-3 h-3 bg-[#ea580c] border border-[#111111] animate-pulse [animation-delay:0.4s]"></div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useLoadingStore } from '../../stores/loading'

const loadingStore = useLoadingStore()
</script>

<style scoped>
/* Ultra-snappy Academic Neobrutalism Entrance & Exit (Zero Perception Jeda) */
.loader-pop-enter-active {
  transition: opacity 0.07s ease-out;
}

.loader-pop-leave-active {
  transition: opacity 0.12s ease-in;
}

.loader-pop-enter-from,
.loader-pop-leave-to {
  opacity: 0;
}

.loader-pop-enter-active .loader-card {
  transition: transform 0.08s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform;
}

.loader-pop-enter-from .loader-card {
  transform: scale(0.96) translate(-2px, -2px);
}

.loader-pop-leave-active .loader-card {
  transition: transform 0.1s ease-in;
}

.loader-pop-leave-to .loader-card {
  transform: scale(0.98);
}
</style>
